define(function (require) {
    "use strict";

    var Browser = require("shared/services/Browser"),
        $       = require("jquery");

    // Constants
    var MAX_POSITION_DELTA = 10, // Maximum distance between start and end touches for it to be a tap, in pixels
        MAX_TIME_DELTA = 400,    // Maximum time between start and end touches for it to be a tap, in milliseconds
        EVENT_NAME = "activate";

    /**
     * Extends jQuery to support a "tap" event. A tap is a touch that is quick and doesn't swipe beyond a certain
     * threshold.
     *
     * The name "activate" represents either a click event on desktop or a tap event on mobile. this is to avoid
     * both tap and click are triggered sometimes in IOS8. see bug MOS-1671.
     *
     *@example
     * $("selector").on("activate", function () {
     *      // handle me...
     * });
     *
     * @class Activate
     * @author Bruce Mackenzie Nielsen
     * @author Yijie Li
     */
    $.event.special[EVENT_NAME] = {

        setup: function () {
            var $this = $(this);

            // Setup click detection if needed
            if (Browser.capabilities.isClicksSupported) {
                $this.on("click." + EVENT_NAME, function (event) {
                        // Some devices fire both touch and mouse events, in order to avoid triggering
                        // "activate" twice, we enforce that a click event cannot occur less than 500
                        // milliseconds from a tap event
                        var timeSinceLastTap = Date.now() - this.tapTimestamp;

                        if (timeSinceLastTap < 500) {
                            return;
                        }

                        event.type = EVENT_NAME;
                        ($.event.dispatch || $.event.handle).call(this, event);
                    });
            }

            // Setup tap detection if needed
            if (Browser.capabilities.isTouchSupported) {
                $this.on("touchstart." + EVENT_NAME, function (event) {
                        // Multiple touches are not considered a tap
                        if (event.originalEvent.touches.length > 1) {
                            this.currentTouch = null;

                            return;
                        }

                        // Don't bother if there's already a touch in progress
                        if (this.currentTouch) {
                            return;
                        }

                        // Grab the initial values and store
                        var touch = event.originalEvent.touches[0];

                        this.currentTouch = {
                            startTime: Date.now(),
                            target: event.target,
                            x: touch.screenX,
                            y: touch.screenY
                        };
                    });

                $this.on("touchend." + EVENT_NAME, function (event) {
                        // Reset state for next tap
                        var startValues = this.currentTouch;
                        this.currentTouch = null;

                        // Cancelled touch
                        if (!startValues) {
                            return;
                        }

                        // Check the time delta
                        if (Date.now() - startValues.startTime > MAX_TIME_DELTA) {
                            return;
                        }

                        // Check the position deltas
                        var touch = event.originalEvent.changedTouches[0],
                            xDelta = Math.abs(touch.screenX - startValues.x),
                            yDelta = Math.abs(touch.screenY - startValues.y);

                        if (xDelta > MAX_POSITION_DELTA || yDelta > MAX_POSITION_DELTA) {
                            return;
                        }

                        event.type = EVENT_NAME;

                        // Keep track of when a tap occurred (used for sanity checking the click handler)
                        this.tapTimestamp = Date.now();

                        ($.event.dispatch || $.event.handle).call(this, event);
                        event.preventDefault();
                    });

                $this.on("touchcancel." + EVENT_NAME, function () {
                        // Reset state for next tap
                        this.currentTouch = null;
                    });
            }
        },

        teardown: function () {
            $(this).unbind("." + EVENT_NAME);
        }
    };
});



// WEBPACK FOOTER //
// ./src/shared/vendor/jquery.activate.js